import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageShell, GoldButton } from "@/components/ds";
import { Reveal } from "@/components/site/Reveal";
import { NewsletterForm } from "@/components/ds/NewsletterForm";
import { DoreCalculator } from "@/components/ds/DoreCalculator";

const ArticleLayout = ({ article }) => (
  <article data-testid="insight-article">
    <PageShell eyebrow={article.date} title={article.title}>
      <p className="text-lg text-zinc-300 leading-relaxed mb-14 border-l-2 border-[#C9A227] pl-6">{article.dek}</p>

      {article.calculator && (
        <Reveal className="mb-14">
          <DoreCalculator />
        </Reveal>
      )}

      {article.sections.map((s, i) => (
        <Reveal key={i}>
          <section className="mb-12">
            <h2 className="font-display text-xl text-[#E8C85A] tracking-wide mb-4">{s.heading}</h2>
            <div className="space-y-4 text-[15px] text-zinc-400 leading-relaxed">
              {s.body.map((p, j) => <p key={j}>{p}</p>)}
            </div>
          </section>
        </Reveal>
      ))}

      {article.related && (
        <div className="mt-16 card-line bg-[#121215] p-8" data-testid="article-related">
          <h2 className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#C9A227] mb-5">Continue through the network</h2>
          <div className="space-y-3">
            {article.related.map((r) => (
              <Link key={r.to} to={r.to} data-testid={`related-${r.to.replace(/\//g, "-")}`}
                className="group flex items-center justify-between gap-4 text-sm text-zinc-300 hover:text-[#E8C85A] transition-colors">
                <span>{r.label}</span>
                <ArrowUpRight size={15} className="text-zinc-600 group-hover:text-[#D4AF37] transition-colors shrink-0" />
              </Link>
            ))}
          </div>
        </div>
      )}

      <div className="mt-12">
        <NewsletterForm testid="article-newsletter" />
      </div>

      <div className="mt-12 pt-10 hairline-t flex flex-wrap items-center justify-between gap-6">
        <Link to="/insights" data-testid="article-back-insights" className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-[#C9A227] hover:text-[#E8C85A] transition-colors">
          ← All briefings
        </Link>
        <GoldButton to="/mandate" testid="article-cta-mandate">Discuss with the desk</GoldButton>
      </div>
    </PageShell>
  </article>
);

export default ArticleLayout;
